import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type SignInMutationPage = { readonly __typename?: 'RootMutationType', readonly signIn: { readonly __typename?: 'AccountsSignIn', readonly user: { readonly __typename?: 'AccountsUser', readonly phone?: string | null, readonly has2fa: boolean }, readonly authToken?: { readonly __typename?: 'AccountsAuthToken', readonly token: string, readonly type: Types.AccountsAuthTokenType, readonly user: { readonly __typename?: 'AccountsUser', readonly id: string, readonly uuid: string, readonly phone?: string | null, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly type?: Types.AccountsUserType | null, readonly budget?: number | null, readonly insertedAt: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null } | null, readonly firstCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly provider: Types.OauthProvider }> } | null } } | null } };


export const SignInDocument = gql`
    mutation SignIn($phone: String!, $password: String!) {
  signIn(phone: $phone, password: $password) {
    user {
      phone
      has2fa
    }
    authToken {
      token
      type
      user {
        id
        uuid
        phone
        roles
        type
        budget
        insertedAt
        profile {
          name
        }
        firstCompany {
          id
          uuid
          name
          tokens {
            id
            provider
          }
        }
      }
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutationPage, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutationPage, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutationPage, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutationPage>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutationPage, SignInMutationVariables>;